(function () {
    'use strict';

    angular.module('app').factory('BusinessStaffService', BusinessStaffService);

    BusinessStaffService.$inject = ['$rootScope', 'API'];

    function BusinessStaffService($rootScope, API) {
        var service = {};
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        /**
         * @typedef MultiLanguageObject
         * @type {Object}
         * @property {string} en - String on English
         * @property {string} pl - String on Polish
         * @property {string} ru - String on Russian
         * @property {string} uk - String on Ukrainian
         */

        /**
         * Return list of Staff
         *
         * @param {object} params - Parameters
         * @param {number} params.page - List page number
         * @param {number} params.count - Objects on page
         * @param {number} params.suspended - Filter by suspended flag
         * @param {number} params.terminal_id - Filter by terminal Id (if needed)
         * @param {string} params.search_text - Filter by search string (contains criteria) in main text fields (name, comment, phone, email)
         * @param {string} params.auth_code - Filter by auth code (matching criteria)
         * @param {'id' | 'create' | 'name' | 'comment' | 'phone' | 'email' | 'auth_code' | 'suspended'} params.sort - Sort field name
         * @param {'asc'|'desc'} params.order - Sort direction
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetsStaff = function (params, callback) {
            API.get('/staff' + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''), function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Return Staff data
         *
         * @param {string} staffId - Staff Id
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetStaff = function (staffId, callback) {
            API.get('/staff/' + staffId, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Add new staff
         *
         * @param {object} staff - Business staff data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.AddStaff = function (staff, callback) {
            API.post('/staff', staff, function (success, data) {
                callback(success, data);
            });
        };

        /**
         * Modify staff data
         *
         * @param {string} staffId - Staff Id
         * @param {object} staff - Business staff data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.UpdateStaff = function (staffId, staff, callback) {
            API.patch('/staff/' + staffId, staff, function (success, data) {
                callback(success, data);
            });
        };

        return service;
    }
})();
